import { Box, TableCell } from "@material-ui/core";
import TableRow from "@material-ui/core/TableRow";
import BugReportIcon from "@material-ui/icons/BugReport";

import NoData from "components/NoData/NoData";

export const ReportBugsTableEmpty = () => {
	return (
		<TableRow>
			<TableCell colSpan={7}>
				<Box py={19}>
					<NoData Icon={BugReportIcon} text={"No Bugs found."} />
				</Box>
			</TableCell>
		</TableRow>
	);
};

export default ReportBugsTableEmpty;
